import { Link } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";
import { animeRoles } from "@/mocks/roles";
import { animeNews } from "@/mocks/news";
import { siteInfo } from "@/mocks/site";
import RoleCard from "@/components/base/RoleCard";
import NewsCard from "@/components/base/NewsCard";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategorySection from "@/pages/home/components/CategorySection";
import HomeSidebar from "@/pages/home/components/HomeSidebar";

export default function Home() {
  useSeo({
    title: "萝莉动漫主题站-二次元萝莉形象及文化资讯",
    description:
      "萝莉网站专注于二次元动漫萝莉形象和相关文化内容，提供丰富的角色介绍、动漫资讯与社区交流，满足萝莉文化爱好者的需求。",
    keywords: "萝莉,动漫萝莉,二次元,萝莉形象,萝莉文化,动漫角色,萝莉资讯"
  });

  const popularRoles = [...animeRoles].sort((a, b) => b.popularity - a.popularity).slice(0, 8);
  const latestNews = [...animeNews].sort((a, b) => b.date.localeCompare(a.date)).slice(0, 6);

  return (
    <div>
      <HeroCarousel />

      <CategorySection />

      <section className="mx-auto max-w-[1280px] px-4 pb-4 md:px-6">
        <div className="mb-6 flex items-end justify-between">
          <div>
            <h2 className="font-heading text-2xl text-foreground-950">热门角色展示</h2>
            <p className="mt-1 text-sm text-foreground-600">近期最受关注的萝莉角色，一睹为快</p>
          </div>
          <Link
            to="/roles"
            className="hidden items-center gap-1 text-sm text-primary-600 transition-colors hover:text-primary-700 sm:flex"
          >
            查看全部
            <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
          {popularRoles.map((role) => (
            <RoleCard key={role.id} role={role} />
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_320px]">
          <div>
            <div className="mb-6 flex items-end justify-between">
              <div>
                <h2 className="font-heading text-2xl text-foreground-950">最新动漫资讯</h2>
                <p className="mt-1 text-sm text-foreground-600">角色动态、新番情报与深度专题</p>
              </div>
              <Link
                to="/news"
                className="hidden items-center gap-1 text-sm text-primary-600 transition-colors hover:text-primary-700 sm:flex"
              >
                更多资讯
                <i className="ri-arrow-right-s-line"></i>
              </Link>
            </div>

            {latestNews.length > 0 ? (
              <div className="space-y-4">
                {latestNews.map((news) => (
                  <NewsCard key={news.id} news={news} />
                ))}
              </div>
            ) : (
              <div className="rounded-lg border border-dashed border-background-300 bg-background-100/60 py-16 text-center text-sm text-foreground-500">
                暂无最新内容
              </div>
            )}
          </div>

          <HomeSidebar />
        </div>
      </section>

      <section className="border-y border-background-200 bg-secondary-50">
        <div className="mx-auto grid max-w-[1280px] grid-cols-1 gap-8 px-4 py-12 md:px-6 md:py-14 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-information-line"></i>
              关于本站
            </span>
            <h2 className="mt-4 text-2xl leading-snug text-foreground-950 md:text-3xl">
              {siteInfo.slogan}
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">{siteInfo.intro}</p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">{siteInfo.mission}</p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/about"
                className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
              >
                了解我们
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/community"
                className="inline-flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                <i className="ri-chat-3-line"></i>
                去社区聊聊
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {[
              { icon: "ri-book-open-line", title: "角色资料库", desc: "多维度标签，精准查找每一位角色" },
              { icon: "ri-newspaper-line", title: "及时资讯", desc: "新番动态、专题解读第一时间送达" },
              { icon: "ri-community-line", title: "友好社区", desc: "和同好一起分享你的本命与热爱" },
              { icon: "ri-shield-check-line", title: "用心整理", desc: "严谨考据，让每份内容都值得信赖" }
            ].map((f) => (
              <div key={f.title} className="rounded-lg border border-background-200 bg-background-50 p-4">
                <span className="mb-3 flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-600">
                  <i className={`${f.icon} text-xl`}></i>
                </span>
                <h3 className="font-heading text-base text-foreground-950">{f.title}</h3>
                <p className="mt-1 text-xs leading-relaxed text-foreground-600">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}